export const exportFile = (
    proxy: string | null,
    api: string,
    url: string,
    token: string | undefined,
    useFreshData?: boolean,
    query?: string
) => {
    const absoluteUrl = proxy ? proxy + api : api

    // Build URLSearchParams safely
    const params = new URLSearchParams()

    if (token) params.append('token', token)
    if (query) {
        // handle if query is already "a=1&b=2"
        const queryParams = new URLSearchParams(query)
        queryParams.forEach((value, key) => params.append(key, value))
    }
    if (useFreshData !== undefined) params.append('useFreshData', String(useFreshData))

    const fetchUrl = `${absoluteUrl}${url}?${params.toString()}`

    const link = document.createElement('a')
    link.href = fetchUrl
    document.body.appendChild(link)
    link.click()
    link.remove()
}
